/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetPdfSettingsQueryResponse, FilesControllerGetPdfSettingsPathParams } from "../../models/filesController/FilesControllerGetPdfSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetPdfSettings } from "../../clients/filesService/filesControllerGetPdfSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetPdfSettingsQueryKey = (id: FilesControllerGetPdfSettingsPathParams["id"], key: FilesControllerGetPdfSettingsPathParams["key"]) => [{
  url: '/api/v1/files/:id/pdf-settings/:key',
  params: {
    id: id,
    key: key
  }
}] as const;
export type FilesControllerGetPdfSettingsQueryKey = ReturnType<typeof filesControllerGetPdfSettingsQueryKey>;
export function filesControllerGetPdfSettingsQueryOptions(id: FilesControllerGetPdfSettingsPathParams["id"], key: FilesControllerGetPdfSettingsPathParams["key"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetPdfSettingsQueryKey(id, key);
  return queryOptions<FilesControllerGetPdfSettingsQueryResponse, ResponseErrorConfig<Error>, FilesControllerGetPdfSettingsQueryResponse, typeof queryKey>({
    enabled: !!(id && key),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetPdfSettings(id, key, config);
    }
  });
}

/**
 * @description Retrieves PDF generation settings from Redis cache by key. Returns 404 if settings have expired or key is invalid.
 * @summary Retrieve PDF generation settings
 * {@link /api/v1/files/:id/pdf-settings/:key}
 */
export function useFilesControllerGetPdfSettings<TData = FilesControllerGetPdfSettingsQueryResponse, TQueryData = FilesControllerGetPdfSettingsQueryResponse, TQueryKey extends QueryKey = FilesControllerGetPdfSettingsQueryKey>(id: FilesControllerGetPdfSettingsPathParams["id"], key: FilesControllerGetPdfSettingsPathParams["key"], options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetPdfSettingsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetPdfSettingsQueryKey(id, key);
  const query = useQuery({
    ...filesControllerGetPdfSettingsQueryOptions(id, key, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}